<h1 mat-dialog-title>
  {{ data.product_task_design_link_id ? 'Editar enlace' : 'Añadir enlace' }}
</h1>

<mat-dialog-content [formGroup]="form">
  <br />

  <mat-form-field appearance="outline" class="w-100" style="margin-bottom: 15px">
    <mat-label>Enlace</mat-label>
    <input matInput formControlName="link" type="url" placeholder="https://..." />
    @if (form.controls['link'].hasError('required')) {
      <mat-error>El enlace es obligatorio</mat-error>
    }
    @if (form.controls['link'].hasError('pattern')) {
      <mat-error>Formato de URL no válido</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Comentario (opcional)</mat-label>
    <textarea matInput formControlName="comment"></textarea>
    @if (form.controls['comment'].hasError('minlength')) {
      <mat-error>El comentario debe tener al menos 10 carácteres</mat-error>
    }
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close()">Cerrar</button>
  <button mat-flat-button color="accent" (click)="save()" [disabled]="!form.valid">
    <mat-icon>save</mat-icon>
    Guardar
  </button>
</mat-dialog-actions>
